import React from 'react';
import { Crown, Shield, Target } from 'lucide-react';

interface TransformationCardProps {
  icon: React.ElementType;
  title: string;
  description: string;
}

const TransformationCard: React.FC<TransformationCardProps> = ({
  icon: Icon,
  title,
  description
}) => (
  <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100 hover:border-blue-200 transition-all duration-300 group">
    <div className="flex items-center gap-4 mb-6">
      <div className="relative">
        <div className="absolute inset-0 bg-blue-100 rounded-full scale-150 opacity-0 group-hover:opacity-20 transition-all duration-300"></div>
        <div className="relative z-10 w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-md">
          <Icon className="w-6 h-6 text-white transform group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
        </div>
      </div>
      <h3 className="text-xl font-bold tracking-tight group-hover:text-blue-600 transition-colors duration-300">{title}</h3>
    </div>
    <div className="pl-16">
      <div className="w-12 h-0.5 bg-gradient-to-r from-blue-500 to-blue-600 mb-4"></div>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  </div>
);

export const TransformationCards: React.FC = () => {
  return (
    <section className="relative -mt-16">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid md:grid-cols-3 gap-6">
          <TransformationCard
            icon={Crown}
            title="STAND OUT FROM COMPETITORS"
            description="Deliver insights others can't match"
          />
          <TransformationCard
            icon={Shield}
            title="REVEAL CUSTOMER MOTIVATIONS"
            description="Illuminate the 'why' behind actions"
          />
          <TransformationCard
            icon={Target}
            title="DRIVE BUSINESS DECISIONS"
            description="Move beyond metrics to strategy"
          />
        </div>
      </div>
    </section>
  );
};